const PUBLIC_POLICY_SLUGS = {
  terms: "terminos-y-condiciones",
  privacy: "privacidad",
  "return-policy": "devoluciones",
  "official-stores-policy": "comercios-autorizados",
  "warranty-policy": "garantias",
} as const

const MERCHANT_POLICY_SLUGS = {
  "product-policy": "productos",
  "shipping-policy": "envios",
  "product-advertising-policy": "publicidad-de-productos",
  "promotions-policy": "promociones",
  "billing-policy": "facturacion",
} as const

export type PublicPolicy = keyof typeof PUBLIC_POLICY_SLUGS
export type MerchantPolicy = keyof typeof MERCHANT_POLICY_SLUGS
export type Policy = PublicPolicy | MerchantPolicy

export const PUBLIC_POLICIES = Object.keys(PUBLIC_POLICY_SLUGS) as PublicPolicy[]

export const isPublicPolicy = (policy: Policy): policy is PublicPolicy => policy in PUBLIC_POLICY_SLUGS

export const policyPath = (policy: Policy): string =>
  isPublicPolicy(policy) ? `/legal/${PUBLIC_POLICY_SLUGS[policy]}` : `/para-comercios/politicas/${MERCHANT_POLICY_SLUGS[policy]}`

export const legacyPolicyRedirects = (): { source: string; destination: string }[] =>
  ([...Object.keys(PUBLIC_POLICY_SLUGS), ...Object.keys(MERCHANT_POLICY_SLUGS)] as Policy[]).map((policy) => ({ source: `/legal/${policy}`, destination: policyPath(policy) }))
